// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleFilledSvg from "@fishx/icons-svg/es/asn/InfoCircleFilled";
import FishxIcon from '../components/FishxIcon';

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleFilledSvg
  }));
};

InfoCircleFilled.displayName = 'InfoCircleFilled';
export default React.forwardRef(InfoCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InfoCircleFilled.js
// module id = 2970
// module chunks = 0